const widgetName = 'socialNetworkWidget';
let initialized = false;

function initialize() {
  initialized = true;
}


// FACEBOOK -----------
let heightCalc = "0"
if ($('body').hasClass('saffireMobileSize')) {
  heightCalc = "379"
} else {
  heightCalc = "535"
}

function facebookfeed() {


  const facebookfeedContainer = `
  <div class="socialFeedWrapper facebook">
    <div class="socialFeedHeading facebookfeedHeading">   
   <span> Follow along</span>
    </div>
    <div id="facebookfeedContainer" class="socialFeedContainer">
      <div class="fb-page" data-href="https://www.facebook.com/people/Brooklyn-Fair/61556313629012/" data-width="457" data-adapt-container-width="true" data-height=${heightCalc} data-small-header="true" data-hide-cover="false" data-show-facepile="false" data-show-posts="true">
        <div class="fb-xfbml-parse-ignore">
          <blockquote cite="https://www.facebook.com/people/Brooklyn-Fair/61556313629012/"><a href="https://www.facebook.com/people/Brooklyn-Fair/61556313629012/">Loading...</a></blockquote>
        </div>
      </div>
    </div>
  </div>
 
  `;

  if (!initialized) {
    initialize();
  }

  $(`#${widgetName}`).append(facebookfeedContainer);


}


// INSTAGRAM -----------

function instafeed() {

  const instafeedContainer = `
  <div class="socialFeedWrapper instafe">
    <div class="socialFeedHeading instafeedHeading">
    Follow us <span>Instagram</span>
    </div>
    <div id="instafeedContainer" class="socialFeedContainer"></div>
  </div>
  `;

  if (!initialized) {
    initialize();
  }

  $(`#${widgetName}`).append(instafeedContainer);

  const feed = new Instafeed({
    target: 'instafeedContainer'
  });
  feed.run();

}

function Mapcontainer(){
  const mapContainer = `
  <div class ="cardWidgetMapp"></div>
  `;
  if (!initialized) {
    initialize();
  }
  $(`#${widgetName}`).append(mapContainer);
}

export { instafeed,Mapcontainer, facebookfeed };